import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '3rem',
    alignItems: 'center',
  },
}));

export default useStyles;
